import { render, staticRenderFns } from "./orderDetails.vue?vue&type=template&id=2edd1050&scoped=true"
import script from "./orderDetails.vue?vue&type=script&lang=js"
export * from "./orderDetails.vue?vue&type=script&lang=js"
import style0 from "./orderDetails.vue?vue&type=style&index=0&id=2edd1050&prod&scoped=true&lang=css"
import style1 from "./orderDetails.vue?vue&type=style&index=1&id=2edd1050&prod&lang=css"
import style2 from "./orderDetails.vue?vue&type=style&index=2&id=2edd1050&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edd1050",
  null
  
)

export default component.exports